import React from 'react';

export default function RouterLoader() {
    return (
        <div style={wrapperStyle}>
            <style>{spinKeyframes}</style>
            <div style={loaderStyle} />
        </div>
    );
}

// Because we want to keep the router as lean as possible so we're not importing from HBUI or styled-components
const wrapperStyle: React.CSSProperties = {
    position: 'fixed',
    inset: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10000
};

const loaderStyle: React.CSSProperties = {
    boxSizing: 'border-box',
    height: 40,
    width: 40,
    padding: 0,
    border: '4px solid #d8dade',
    borderRight: '4px solid #232529',
    borderBottom: '4px solid #232529',
    borderLeft: '4px solid #232529',
    borderRadius: '100%',
    animation: 'router-loader-spin 0.5s infinite linear'
};

const spinKeyframes = `
@keyframes router-loader-spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}`;
